import BillingModel from "../../../../types/billing-model";

export enum OrderCargoOrderHistoryChangeRideEventType {
  ADD_CARGO_ENTER = "ADD_CARGO_ENTER",
  ADD_CARGO_EXIT = "ADD_CARGO_EXIT",
  CHANGE_HALTING_TIME = "CHANGE_HALTING_TIME",
  CHANGE_POSITION = "CHANGE_POSITION",
  CHANGE_TIME = "CHANGE_TIME",
  CREATE_INNER_RIDE = "CREATE_INNER_RIDE",
  DELETE_NODE = "DELETE_NODE",
  DO_NOTHING = "DO_NOTHING",
  INSERT_NODE_BEFORE = "INSERT_NODE_BEFORE",
  INSERT_NODE_AFTER = "INSERT_NODE_AFTER",
  REMOVE_CARGO_ENTER = "REMOVE_CARGO_ENTER",
  REMOVE_CARGO_EXIT = "REMOVE_CARGO_EXIT",
  SQUASH_INNER_RIDE = "SQUASH_INNER_RIDE",
}

export enum OrderCargoOrderHistoryEventType {
  BIND_PASSENGER = "BIND_PASSENGER",
  CANCEL_ORDER = "CANCEL_ORDER",
  CHANGE_RIDE = "CHANGE_RIDE",
  CHANGE_TARGET_TAXI = "CHANGE_TARGET_TAXI",
  DEALER_APPROVAL = "DEALER_APPROVAL",
  DISPATCH_APPROVAL = "DISPATCH_APPROVAL",
  EXTERNAL_ID_UPDATE = "EXTERNAL_ID_UPDATE",
  INITIALIZE = "INITIALIZE",
  MERGE_ORDERS = "MERGE_ORDERS",
  OPERATIONAL_APPROVAL = "OPERATIONAL_APPROVAL",
  REQUEST_CANCEL_ORDER = "REQUEST_CANCEL_ORDER",
  REVERT_CANCEL_ORDER_REQUEST = "REVERT_CANCEL_ORDER_REQUEST",
  SHUFFLE_MERGE = "SHUFFLE_MERGE_COMMAND",
  FORWARD_ADD = "FORWARD",
  FORWARD_CANCEL = "FORWARD_CANCEL",
  ACCEPTED_CPE_CANDIDATURE = "ACCEPTED_CPE_CANDIDATURE",
  ACCEPTED_CSO_CANDIDATURE = "ACCEPTED_CSO_CANDIDATURE",
  ACCEPTED_DSO_CANDIDATURE = "ACCEPTED_DSO_CANDIDATURE",
}

export type OrderCargoOrderHistoryItemSubject = {
  time: string | null;
  haltingTime: number;
  displayName: string;
};

export type OrderCargoOrderHistoryItemAddCargoEnterChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.ADD_CARGO_ENTER;
};

export type OrderCargoOrderHistoryItemAddCargoExitChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.ADD_CARGO_EXIT;
};

export type OrderCargoOrderHistoryItemChangeHaltingTimeChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.CHANGE_HALTING_TIME;
  haltingTime: number;
};

export type OrderCargoOrderHistoryItemChangePositionChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.CHANGE_POSITION;
  displayName: string;
};

export type OrderCargoOrderHistoryItemChangeTimeChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.CHANGE_TIME;
  time: string | null;
};

export type OrderCargoOrderHistoryItemCreateInnerRideChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.CREATE_INNER_RIDE;
};

export type OrderCargoOrderHistoryItemDeleteNodeChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.DELETE_NODE;
};

export type OrderCargoOrderHistoryItemDoNothingChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.DO_NOTHING;
};

export type OrderCargoOrderHistoryItemInsertNodeAfterChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.INSERT_NODE_AFTER;
  subject: OrderCargoOrderHistoryItemSubject;
};

export type OrderCargoOrderHistoryItemInsertNodeBeforeChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.INSERT_NODE_BEFORE;
  subject: OrderCargoOrderHistoryItemSubject;
};

export type OrderCargoOrderHistoryItemRemoveCargoEnterChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.REMOVE_CARGO_ENTER;
};

export type OrderCargoOrderHistoryItemRemoveCargoExitChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.REMOVE_CARGO_EXIT;
};

export type OrderCargoOrderHistoryItemSquashInnerRideChangeRideCommand = {
  commandType: OrderCargoOrderHistoryChangeRideEventType.SQUASH_INNER_RIDE;
};

export type OrderCargoOrderHistoryItemChangeRideCommandUpdateRideCommand =
  | OrderCargoOrderHistoryItemAddCargoEnterChangeRideCommand
  | OrderCargoOrderHistoryItemAddCargoExitChangeRideCommand
  | OrderCargoOrderHistoryItemChangeHaltingTimeChangeRideCommand
  | OrderCargoOrderHistoryItemChangePositionChangeRideCommand
  | OrderCargoOrderHistoryItemChangeTimeChangeRideCommand
  | OrderCargoOrderHistoryItemCreateInnerRideChangeRideCommand
  | OrderCargoOrderHistoryItemDeleteNodeChangeRideCommand
  | OrderCargoOrderHistoryItemDoNothingChangeRideCommand
  | OrderCargoOrderHistoryItemInsertNodeAfterChangeRideCommand
  | OrderCargoOrderHistoryItemInsertNodeBeforeChangeRideCommand
  | OrderCargoOrderHistoryItemRemoveCargoEnterChangeRideCommand
  | OrderCargoOrderHistoryItemRemoveCargoExitChangeRideCommand
  | OrderCargoOrderHistoryItemSquashInnerRideChangeRideCommand;

export type OrderCargoOrderHistoryItemInitializeCommandRideWaypoint = {
  time: string | null;
  haltingTime: number;
  displayName: string;
};

export type OrderCargoOrderHistoryDataRideSeqItem =
  | OrderCargoOrderHistoryItemInitializeCommandRideWaypoint
  | OrderCargoOrderHistoryItemInitializeCommandRide;

export type OrderCargoOrderHistoryItemInitializeCommandRide = {
  seq: OrderCargoOrderHistoryDataRideSeqItem[];
};

export type OrderCargoOrderHistoryItemBindPassengerCommand = {
  commandType: OrderCargoOrderHistoryEventType.BIND_PASSENGER;
};

export type OrderCargoOrderHistoryItemCancelOrderCommand = {
  commandType: OrderCargoOrderHistoryEventType.CANCEL_ORDER;
};

export type OrderCargoOrderHistoryItemChangeRideCommand = {
  commandType: OrderCargoOrderHistoryEventType.CHANGE_RIDE;
  updateRideCommandSequence: OrderCargoOrderHistoryItemChangeRideCommandUpdateRideCommand[];
};

export type OrderCargoOrderHistoryItemChangeTargetTaxiCommand = {
  commandType: OrderCargoOrderHistoryEventType.CHANGE_TARGET_TAXI;
};

export type OrderCargoOrderHistoryItemDealerApprovalCommand = {
  commandType: OrderCargoOrderHistoryEventType.DEALER_APPROVAL;
  approvingDealerId: string;
};

export type OrderCargoOrderHistoryItemDispatchApprovalCommand = {
  commandType: OrderCargoOrderHistoryEventType.DISPATCH_APPROVAL;
  approvingDispatcherId: string;
};

export type OrderCargoOrderHistoryItemExternalIdUpdateCommand = {
  commandType: OrderCargoOrderHistoryEventType.EXTERNAL_ID_UPDATE;
  newExternalId: string;
};

export type OrderCargoOrderHistoryItemInitializeCommand = {
  commandType: OrderCargoOrderHistoryEventType.INITIALIZE;
  externalId: string | null;
  ride: OrderCargoOrderHistoryItemInitializeCommandRide;
};

export type OrderCargoOrderHistoryItemOperatorApprovalCommand = {
  commandType: OrderCargoOrderHistoryEventType.OPERATIONAL_APPROVAL;
  approvingOperatorId: string;
};

export type OrderCargoOrderHistoryItemMergeOrderCommand = {
  commandType: OrderCargoOrderHistoryEventType.MERGE_ORDERS;
};

export type OrderCargoOrderHistoryItemRequestCancelOrderCommand = {
  commandType: OrderCargoOrderHistoryEventType.REQUEST_CANCEL_ORDER;
};

export type OrderCargoOrderHistoryItemRevertCancelOrderRequestCommand = {
  commandType: OrderCargoOrderHistoryEventType.REVERT_CANCEL_ORDER_REQUEST;
};

export type OrderCargoOrderHistoryItemShuffleMergeCommandRepresentationTarget =
  {
    humanId: string;
  };

export type OrderCargoOrderHistoryItemShuffleMergeCommandRepresentationSources =
  {
    humanId: string;
  };

export type OrderCargoOrderHistoryItemShuffleMergeCommandRepresentation = {
  target: OrderCargoOrderHistoryItemShuffleMergeCommandRepresentationTarget;
  sources: OrderCargoOrderHistoryItemShuffleMergeCommandRepresentationSources[];
};

export type OrderCargoOrderHistoryItemShuffleMergeCommand = {
  commandType: OrderCargoOrderHistoryEventType.SHUFFLE_MERGE;
  representation: OrderCargoOrderHistoryItemShuffleMergeCommandRepresentation;
};

export type OrderCargoOrderHistoryItemPerformedCommand =
  | OrderCargoOrderHistoryItemBindPassengerCommand
  | OrderCargoOrderHistoryItemCancelOrderCommand
  | OrderCargoOrderHistoryItemChangeRideCommand
  | OrderCargoOrderHistoryItemChangeTargetTaxiCommand
  | OrderCargoOrderHistoryItemDealerApprovalCommand
  | OrderCargoOrderHistoryItemDispatchApprovalCommand
  | OrderCargoOrderHistoryItemExternalIdUpdateCommand
  | OrderCargoOrderHistoryItemInitializeCommand
  | OrderCargoOrderHistoryItemMergeOrderCommand
  | OrderCargoOrderHistoryItemOperatorApprovalCommand
  | OrderCargoOrderHistoryItemRequestCancelOrderCommand
  | OrderCargoOrderHistoryItemRevertCancelOrderRequestCommand
  | OrderCargoOrderHistoryItemShuffleMergeCommand;

export type OrderCargoOrderHistoryItemAuthor = {
  firstName: string;
  lastName: string;
};

export type OrderCargoOrderHistoryItem = {
  createdAt: string;
  author: OrderCargoOrderHistoryItemAuthor;
  performedCommand: OrderCargoOrderHistoryItemPerformedCommand;
  cargoTaxiBillingModel: BillingModel | null;
  taxiCorporationDisplayName: string | null;
};

type OrderCargoOrderHistory = {
  data: OrderCargoOrderHistoryItem[];
};

export default OrderCargoOrderHistory;
